var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline-danger btn-round btn-mini",attrs:{"title":"Убрать из сравнения"},on:{"click":function($event){$event.preventDefault();return _vm.toggle_click(_vm.bib)}}},[_vm._v("×")])
}
var staticRenderFns = []

export { render, staticRenderFns }